import React, { useState } from "react";
import { Card } from "../../../Components/ui/card";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "../../../Components/ui/hover-card";
import { AlertTriangle, Info, Pencil, XIcon } from "lucide-react";
import { SquarePen } from 'lucide-react';

interface Props {
    content: string;
    partsCount: number;
    showWarning: boolean;
    onContentChange?: (val: string) => void;
}

const CreateContentSMSCard: React.FC<Props> = ({ content, partsCount, showWarning, onContentChange }) => {
    const [isEditing, setIsEditing] = useState(false);

    const formatText = (text: string) => {
        return text
            .replace(/\*(.*?)\*/g, "<strong>$1</strong>")
            .replace(/_(.*?)_/g, "<em>$1</em>")
            .replace(/~(.*?)~/g, "<s>$1</s>")
            .replace(/`(.*?)`/g, "<code>$1</code>");
    };

    const noContentSelected = !content?.trim();


    return (
        <div className="w-full max-w-[500px] border rounded-lg p-3 min-h-0 flex flex-col">
            <div className="flex items-center justify-between mb-2">
                <h2 className="font-bold">Content Preview</h2>
                {!noContentSelected && (
                    <div className="flex items-center gap-2">
                        {/* <span className="text-xs text-gray-400">{content.length} chars</span> */}
                        <button
                            className="text-black-400 hover:text-blue-500"
                            onClick={() => setIsEditing((prev) => !prev)}
                            title="Edit content"
                        >
                            {isEditing ? <XIcon className="w-4 h-4" /> : <SquarePen className="w-4 h-4" />}
                        </button>
                    </div>
                )}
            </div>

            {/* Character Count */}
            {/* <div className="text-xs text-gray-500 text-right mb-2">
                Character Count: {content.length}
            </div> */}


            {/* Content Area */}

<div className="bg-[#F0F4F8] rounded-2xl p-3 min-h-[400px] overflow-y-auto relative">
  {noContentSelected ? (
    <div className="flex flex-col h-full justify-center items-center text-gray-500">
      <p className="text-xl">Mobile screen</p>
    </div>
  ) : isEditing ? (
    <textarea
      className="w-full h-full min-h-[400px] bg-transparent text-sm resize-none outline-none"
      value={content}
      onChange={(e) => onContentChange?.(e.target.value)}
    />
  ) : (
    <div
      className="whitespace-pre-wrap break-words text-sm"
      dangerouslySetInnerHTML={{ __html: formatText(content) }}
    />
  )}
</div>
        </div>
    );
};

export default CreateContentSMSCard;
